import React, { useContext, useEffect, useState } from 'react';
import Loader from '../../../components/Loader/Loader';
import { getAllOrders } from '../../../http/ordersAPI';
import Pagination from '../../../components/Pagination/Pagination';
import OrdersItem from '../OrdersItem/OrdersItem';
import styles from './OrdersList.module.scss';
import { Button,
  //  Pagination 
  } from 'react-bootstrap';
import { AuthContext } from '../../../context/AuthContext';
import MyTextInput from '../../MyForms/MyTextInput/MyTextInput';

const OrdersList = () => {
  const admin = useContext(AuthContext).permissions?.admin?.access;
  const [activeTab, setActiveTab] = useState('all');
  const [statusFilter, setStatusFilter] = useState('Усі замовлення');
  const [searchInput, setSearchInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [orders, setOrders] = useState([]);
  const [ordersQuantity, setOrdersQuantity] = useState(0);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [filters, setFilters] = useState({
    activeTab: 'all',
    currentPage: 1,
    statusFilter: 'Усі замовлення',
    searchInput: ''
  });
  const perPage = 10;

  useEffect(() => {
    const ordersFilter = {
      perPage,
      startPage: currentPage,
      sort: '-date'
    };

    if (statusFilter !== 'Усі замовлення') {
      ordersFilter.status = statusFilter;
    }
    if (searchInput.trim()) {
      ordersFilter.find = searchInput.trim();
    }
    if (activeTab === 'novaposhta') {
      ordersFilter.delivery = 'Нова пошта';
    }
    if (activeTab === 'pickup') {
      ordersFilter.delivery = 'Самовивіз';
    }

    setOrdersLoading(true);
    getAllOrders(admin, ordersFilter).then(res => {
      setOrders(res.data.orders);
      setOrdersQuantity(res.data.ordersQuantity);
      setOrdersLoading(false);
    });
  }, [activeTab, currentPage, statusFilter, searchInput]);

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        <button
          className={activeTab === 'all' ? styles.activeTab : ''}
          onClick={() => {
              setActiveTab(prev => {
                setCurrentPage(1);
                return 'all';
              })
          }}
        >
          Усі
        </button>
        <button
          className={activeTab === 'novaposhta' ? styles.activeTab : ''}
          onClick={() => {
            setActiveTab(prev => {
              setCurrentPage(1);
              return 'novaposhta';
            });
          }}
        >
          Нова Пошта
        </button>
        <button
          className={activeTab === 'pickup' ? styles.activeTab : ''}
          onClick={() => {
            setActiveTab(prev => {
              setCurrentPage(1);
              return 'pickup'
            });
            
          }}
        >
          Самовивіз
        </button>
      </div>

      <div className={styles.filter}>
        <div className={styles.filterWrapper}>
          <label>Пошук по № замовлення або імені та прізвищу</label>
          <input
            onChange={e => {
              setSearchInput(e.target.value);
              setCurrentPage(1);
            }}
            name="search"
            type="text"
            placeholder="Пошук"
          />
        </div>
        <div className={styles.filterWrapper}>
          <label>Статус</label>
          <select
            onChange={e => {
              setStatusFilter(e.target.value);
              setCurrentPage(1);
            }}
            value={statusFilter}
            className={styles.select}
          >
            <option>Усі замовлення</option>
            <option value="specified">Уточнюються</option>
            <option value="processed">В обробці</option>
            <option value="send">Відправлені</option>
            <option value="completed">Виконані</option>
            <option value="abolition">Відмінити</option>
          </select>
        </div>
      </div>

      {ordersLoading && orders.length === 0 ? (
        <Loader />
      ) : (
        <ul>
          {orders.map(order => (
            <li key={order.orderNo}>
              <OrdersItem order={order} />
            </li>
          ))}
        </ul>
      )}

      <Pagination
        perPage={perPage}
        startPage={currentPage}
        setPage={setCurrentPage}
        productsQuantity={ordersQuantity}
      />
    </div>
  );
};


export default OrdersList;
